import { useCallback, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import { getScrollParent, scrollIntoViewport } from '@react-aria/utils';

export type UseScrollIntoViewProps = {
  isDisabled?: boolean;
};

export function useScrollIntoViewOnMount<T extends HTMLElement>({ isDisabled }: UseScrollIntoViewProps = {}) {
  const { ref } = useInView();
  const hasAttachedRef = useRef(false);

  const callbackRef = useCallback(
    (node: T | null) => {
      ref(node);
      if (!node || hasAttachedRef.current) {
        return;
      }
      hasAttachedRef.current = true;
      if (!isDisabled) {
        scrollIntoViewport(node, { containingElement: getScrollParent(node) });
      }
    },
    [isDisabled, ref],
  );

  return { ref: callbackRef };
}
